var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShedule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.25H11V2.25H10V3.25H6V2.25H5V3.25H3C2.44667 3.25 2 3.69667 2 4.25V14.25C2 14.8033 2.44667 15.25 3 15.25H13C13.5533 15.25 14 14.8033 14 14.25V4.25C14 3.69667 13.5533 3.25 13 3.25ZM13 14.25H3V7.25H13V14.25ZM13 6.25H3V4.25H5V5.25H6V4.25H10V5.25H11V4.25H13V6.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShedule);
export default __webpack_public_path__ + "static/media/ic-shedule.2863cd2430dcc8a3389cee3a8b51e98e.svg";
export { ForwardRef as ReactComponent };